import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { mockup, pricing, stickyBar } from "../data/content";
import { BuyButton } from "./BuyButton";
const ease = [0.23, 1, 0.32, 1] as const;
export function StickyBuyBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerInView, setOfferInView] = useState(false);
  useEffect(() => {
    const heroCta = document.getElementById("hero-cta");
    const offerSection = document.getElementById("oferta");
    const observers: IntersectionObserver[] = [];
    if (heroCta) {
      const o = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting && entry.boundingClientRect.top < 0));
      o.observe(heroCta);
      observers.push(o);
    }
    if (offerSection) {
      const o = new IntersectionObserver(([entry]) => setOfferInView(entry.isIntersecting), {
        threshold: 0.15
      });
      o.observe(offerSection);
      observers.push(o);
    }
    return () => observers.forEach(o => o.disconnect());
  }, []);
  const visible = pastHero && !offerInView;
  return <AnimatePresence data-id="element-198" data-mp="2edkkx7f4522d">
      {visible}
    </AnimatePresence>;
}